import { round } from 'lodash';

export default function setFastAccessMenuTopV2(): void {
    const bottom = round(document.querySelector('.sticky')!.getBoundingClientRect().bottom);
    (document.querySelector('.atmo-fast-access-menu') as HTMLElement).style.setProperty('--top', `${bottom}px`);
}
